const DoctorFilter = {
	en: {
		sort: "Sort by",
		more: "More",
		less: "Less",
	},
	es: {
		sort: "Ordenar por",
		more: "Más",
		less: "Menos",
	},
	ko: {
		sort: "Triye pa",
		more:"Plis",
		less: "Mwens",
	}
};
export default DoctorFilter;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-filter/doctor-filter.language.js